// extracted by mini-css-extract-plugin
export var container = "page-module--container--2TXqA";
export var content = "page-module--content--17ntJ";
export var coverImage = "page-module--coverImage--L3-kK";